import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        folders: {}, //Object of objects in order so no api calls made if going back through folders

        currentFolderPath: [],

        currentFolderID: null,

        loadingFiles: false,

        job: {},
        job_type: null,
        job_id: null,
        isDisabled: false,
        isCore: false,

        clipboard: {},
        selectedFiles: {},

        sidebarOpen: false
    },

    actions: {

        ////////////////////
        //Folder Control////
        ////////////////////

        getFolders(context, folderID = null){
            context.commit('setLoadingFiles', true);

            console.log(folderID);
            let folder = context.state.folders[folderID];

            // let id = context.state.job_id;
            // if(folder !== undefined){
            //     if(
            //         folder.folder_job_type != context.state.job_type
            //         &&
            //         context.state.job.tender_id != undefined
            //     ){
            //         id = context.state.job.tender_id;
            //     }
            // }

            return new Promise(function(resolve, reject){
                axios.get('/api/documents/folder/get', {
                    params: {
                        folder: folderID,
                        type: context.state.job_type,
                        id: context.state.job_id
                    }
                }).then(function(response){
                    context.commit('appendFolders', response.data);

                    resolve(response);

                    context.commit('setLoadingFiles', false);
                }).catch(function(response){
                    reject(response);
                });
            });
        },
        selectFolder(context, folderID){
            context.commit('setLoadingFiles', true);
            context.commit('setCurrentFolder', folderID);

            context.dispatch('getFolders',folderID).then(function(response){
                if(folderID != null){
                    context.commit('appendToPath', folderID);
                } else {
                    context.commit('resetPath');
                }
            });
        },

        back(context){
            if(context.state.currentFolderID != null){
                context.commit('removeFromPath');

                let currentFolder = context.state.folders[context.state.currentFolderID];
                let folderID = currentFolder.parent_id;
                if(currentFolder.parent_id == null && currentFolder.job_type_name != context.state.job_type){
                    folderID = Object.values(context.state.folders).find(function (folder) {
                        return (
                            folder.parent_id == null &&
                            folder.folder_job_type == currentFolder.job_type &&
                            folder.job_type != folder.folder_job_type
                        );
                    })['id'];
                }

                context.commit('setCurrentFolder', folderID);
            }
        },
        gotoFolder(context, folderID){
            context.commit('setCurrentPath', folderID);
            context.dispatch('selectFolder', folderID);
        },

        ////////////////////
        //Editting Folders//
        ////////////////////

        createFolder(context, data){
            axios.post('/api/documents/folder/create',
                $.extend(
                    data,
                    {
                        job_type: context.state.job_type,
                        job_id: context.state.job_id
                    }
                )
            ).then(function(response){
                toastr.success(response.data.message);
                context.commit('appendFolders', response.data);

                if(data.parent != undefined){
                    data.parent();
                }
            });
        },

        editFolder(context, data){
            axios.post('/api/documents/folder/' + data.folder_id + '/edit', data).then(function(response){
                toastr.success(response.data.message);
                context.commit('appendFolders', response.data);
            });
        },

        deleteFolder(context, folderID){
            axios.delete('/api/documents/folder/' + folderID + '/delete').then(function(response){
                toastr.success(response.data.message);
                if(folderID == context.state.currentFolderID){
                    context.dispatch('back');
                }
                context.commit('removeFolder', folderID);
            });
        },

        ////////////////////
        //File Control//////
        ////////////////////

        editFile(context, data){
            axios.post('/api/documents/file/' + data.file_id + '/update', data).then(function(response){
                toastr.success(response.data.message);
                context.commit('appendFolders', response.data);
            });
        },

        deleteFile(context, fileID){
            Swal.fire({
                title: 'Do you want to delete this file?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Delete All',
                cancelButtonText: 'Delete File',
            }).then((response) => {
                if(response.value){
                    axios.delete('/api/documents/file/' + fileID + '/delete', {data: { remove_all: true }}).then(function(response){
                        context.commit('appendFolders', response.data);

                        Swal.fire(
                            'Deleted!',
                            'The file has been deleted.',
                            'success'
                        );
                    });
                }

                if(response.dismiss == 'cancel'){
                    axios.delete('/api/documents/file/' + fileID + '/delete').then(function(response){

                        context.commit('appendFolders', response.data);

                        Swal.fire(
                            'Deleted!',
                            'The file has been deleted.',
                            'success'
                        );
                    });
                }
            });
        },

        selectFile(context, file){
            context.commit('selectFile', file);
        },

        selectFileForCopy(context, file){
            context.commit('selectFileForCopy', file);
        },

        copyFile(context, folder_id){
            Object.values(context.state.clipboard).forEach(function(file){
                let data = {
                    folder_id: folder_id,
                    job_type: context.state.job_type,
                    job_id: context.state.job_id
                };

                axios.post('/api/documents/file/' + file.id + '/copy', data).then(function(response){
                    toastr.success(response.data.message);
                    context.commit('appendFolders', response.data);
                });
            });
        }
    },

    mutations: {

        ////////////////////
        //GENERIC SETTERS///
        ////////////////////

        setJob(state, job){
            state.job = job;
        },

        setJobType(state, job_type){
            state.job_type = job_type;
        },

        setJobID(state, job_id){
            state.job_id = job_id;
        },

        setIsDisabled(state, disabled){
            state.isDisabled = disabled;
        },

        setIsCore(state, core){
            state.isCore = core;
        },

        setCurrentFolderID(state, folderID){
            state.currentFolderID = folderID;
        },

        setLoadingFiles(state, loading){
            loading = loading == null ? false : loading;

            if(state != null){
                state.loadingFiles = loading;
            }
        },

        ////////////////////
        //PATH//////////////
        ////////////////////

        setCurrentPath(state, folderID){
            let remove = false;
            state.currentFolderPath = state.currentFolderPath.filter(function(folderPathFolderID){
                if(folderPathFolderID == folderID){
                    remove = true;
                } else {
                    return !remove;
                }

                return true;
            });
        },

        appendToPath(state, folderID){
            let finalPathFolderID = state.currentFolderPath[state.currentFolderPath.length - 1];
            let folder = state.folders[folderID];
            if(finalPathFolderID != undefined){
                let finalPathFolder = state.folders[finalPathFolderID];

                if(
                    finalPathFolder.parent_id == folder.parent_id &&
                    finalPathFolder.job_type == finalPathFolder.folder_job_type ||
                    (finalPathFolder.job_type == null && finalPathFolder.parent_id == folder.parent_id) ||
                    finalPathFolder.folder_job_type != folder.folder_job_type ||
                    finalPathFolder.id == folder.id
                ) {
                    state.currentFolderPath.pop();
                }
            }
            state.currentFolderPath.push(folderID);
        },

        removeFromPath(state){
            state.currentFolderPath.pop();
        },

        resetPath(state){
            state.currentFolderPath = [];
        },

        ////////////////////
        //FOLDERS///////////
        ////////////////////

        appendFolders(state, options){
            state.folders = Object.assign({}, state.folders, options.folders);
        },
        setCurrentFolder(state, folderID){
            state.currentFolderID = folderID;
        },
        removeFolder(state, folderID){
            let parentID = state.folders[folderID].parent_id;
            Vue.delete(state.folders, folderID);

            //as children aren't keyed by the id they need to be deleted through iteration over the children of the parent
            if(state.folders[parentID] != undefined){
                Object.keys(state.folders[parentID].children).forEach(function(index){
                     if(state.folders[parentID].children[index].id == folderID){
                         Vue.delete(state.folders[parentID].children, index);
                     }
                })
            }
        },

        ////////////////////
        //FILES/////////////
        ////////////////////
        selectFile(state, file){
            if(state.selectedFiles[file.id] != undefined){
                Vue.delete(state.selectedFiles, file.id);
            } else {
                Vue.set(state.selectedFiles, file.id, file);
            }
        },
        selectFileForCopy(state, file){
            if(state.clipboard[file.id] != undefined){
                Vue.delete(state.clipboard, file.id);
            } else {
                Vue.set(state.clipboard, file.id, file);
            }
        },

        ////////////////////
        //SIDEBAR///////////
        ////////////////////
        openSidebar(state, open){
            state.sidebarOpen = open;
        },
    },

    getters: {

        //Folder Getters

        getCurrentFolders: function(state){
            if(state.currentFolderID != null){
                if(state.folders[state.currentFolderID] != undefined){
                    return state.folders[state.currentFolderID].children;
                }
            }
        },
        getParentFolders: function(state){
            if(state.currentFolderID == null){
                return Object.values(state.folders).filter(function(folder){
                    if(state.job_type == null){
                        return folder.parent_id == null;
                    }
                    return folder.job_type_name == state.job_type && folder.parent_id == null;
                });
            } else {
                let currentFolder = state.folders[state.currentFolderID];

                if(currentFolder != undefined) {
                    let parentFolder = state.folders[currentFolder.parent_id];

                    currentFolder.job_type_name = currentFolder.job_type_name == 'N/A' ? null : currentFolder.job_type_name;
                    if(currentFolder.parent_id == null && state.job_type != currentFolder.job_type_name){
                        return Object.values(state.folders).filter(function (folder) {
                            return folder.job_type == currentFolder.job_type && folder.parent_id == null;
                        });
                    }

                    if (parentFolder != undefined) {
                        return parentFolder.children;
                    }

                    return Object.values(state.folders).filter(function (folder) {
                        return folder.job_type_name == state.job_type && folder.parent_id == null;
                    });

                }
            }
        },

        //File Getters

        getCurrentFiles: function(state){
            if(state.currentFolderID != null){
                if(state.folders[state.currentFolderID] != undefined){
                    return state.folders[state.currentFolderID].files;
                }
            }
        },

        //Generic Getters

        getParentID(state){
            let currentFolder = state.folders[state.currentFolderID];

            if(currentFolder != undefined) {
                if(currentFolder.job_type_name != state.job_type && state.job_type != null && currentFolder.parent_id == null){
                    return Object.values(state.folders).find(function (folder) {
                        return (
                            folder.parent_id == null &&
                            folder.job_type != folder.folder_job_type &&
                            (
                                folder.folder_job_type == currentFolder.job_type ||
                                folder.job_type == currentFolder.job_type
                            )
                        );
                    })['id'];
                }

                return currentFolder.parent_id;
            }
        },

        buildPermission: (state) => (type) => {
            return `${state.isCore ? 'core ' : ''}${state.job_type == null ? 'central' : state.job_type} documents|${type}`;
        }

    }
});
